<template>
  <div class="cont-box" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <img class="title-header" src="../../assets/map-bg.png" />
    <div class="list">
      <div class="title-cont">
        <img class="title-img" src="../../assets/b-title-des.png" />
        <p class="title">年度经营指标完成情况</p>
        <img class="title-img resever" src="../../assets/b-title-des.png" />
        <p class="time" v-if="date">( 截止{{date.substring(0, 4)+'.'+date.substring(5, 7)+' )'}}</p>
      </div>
      <div class="mapAll">
        <Echart07 id="mapChinaAll" :datas="data02" height="300px" />
      </div>
    </div>
    <div class="list">
      <div class="title-cont">
        <img class="title-img" src="../../assets/b-title-des.png" />
        <p class="title">{{indexCur}}月各省份经营指标完成率</p>
        <img class="title-img resever" src="../../assets/b-title-des.png" />
      </div>
      <div class="month-box">
        <div v-for="(item, index) in monthArr" :key="index" :class="indexCur === item ? 'month-cur' : '' "
          @click="setMonth(item)"><span>{{item}}</span></div>
      </div>
      <div class="map">
        <MapChina id="mapChina" :datas="datas" height="280px" :month="monthArr[indexCur -1]"></MapChina>
      </div>
    </div>
    <NavStyle :navIndex="1"></NavStyle>
  </div>
</template>

<script>
  import MapChina from '../../components/MapChina.vue'
  import Echart07 from '../../components/Echart07.vue'
  import NavStyle from '../../components/NavStyle.vue'

  export default {
    name: 'Map',
    components: {
      MapChina,
      Echart07,
      NavStyle
    },
    data() {
      return {
        loading: true,
        indexCur: 1,
        navCur: false,
        monthArr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        datasDefault: [],
        date: '',
        data02:[
          // {type:'合同', mb: 100, lj: 200, qd: 30},
          // {type:'回款', mb: 100, lj: 200, qd: 30},
          // {type:'费用', mb: 100, lj: 200, qd: 30},
          // {type:'中标', mb: 100, lj: 200, qd: 30},
          // {type:'收入', mb: 100, lj: 200, qd: 30}
        ]
      }
    },
    computed: {
      datas() {
        let arr = []
        if(!this.datasDefault) {
          return []
        }
        this.datasDefault.map(item => {
          arr.push({name: item.province, value: item.value.htWcl})
        })
        return arr
      }
    },
    mounted() {
	  this.getloginCode()
      // this.getData()
    },
    methods: {
	  getloginCode(){
		  const code = this.$router.history.current.query.code || this.$store.state.code
      if(code) this.$store.commit('SET_CODE', code)
		  this.$axios.post('/wechat/reportMarket',{code}).then(res => {
        if(res.data?.loginPerson) {
          this.$store.commit('SET_SellData', res.data)
        }
			  // this.loginPerson = res.data.loginPerson 
			  this.loading = true
			  // this.$axios.post('/sellDataView/findObjectList',{username: this.loginPerson, month: this.indexCur.toString()}).then(res => {
			  this.$axios.post('/sellDataView/findObjectList',{username: this.$store.state.sellData.loginPerson, month: this.indexCur.toString()}).then(res => {
			  // this.$axios.post('/sellDataView/findObjectList',{username: '秦旭东', month: this.indexCur.toString()}).then(res => {
			    // console.log(res.data)
			    this.datasDefault = res.data.province
			    this.data02 = res.data.sum
			    this.date = res.data.timeFlag
			    this.$store.commit('SET_SellDataP', res.data.province)
			    this.loading = false
			  }).catch(err => {
			    this.loading = false
			  })
			  
			  
		  }).catch(err => {
		    this.loading = false
		  })
	  },
      getData() {
        this.loading = true
        this.$axios.post('/sellDataView/findObjectList',{username: this.$store.state.sellData.loginPerson, month: this.indexCur.toString()}).then(res => {
        // this.$axios.post('/sellDataView/findObjectList',{username: '秦旭东', month: this.indexCur.toString()}).then(res => {
          // console.log(res.data)
          this.datasDefault = res.data.province
          this.data02 = res.data.sum
          this.date = res.data.timeFlag
          this.$store.commit('SET_SellDataP', res.data.province)
          this.loading = false
        }).catch(err => {
          this.loading = false
        })
      },
      mergeArr(arr1, arr2, key) {
        let resultArr = []
        arr1.map((item1) => {
          let flag = true
          for(let i = 0; i < arr2.length; i ++) {
            if(item1[key] === arr2[i][key]) {
              flag = false
              resultArr.push(arr2[i])
              break
            }
          }
          flag ? resultArr.push(item1) : ''
        })
        return resultArr
      },
      setMonth(e) {
        this.indexCur = e
        this.getData()
      }
    }
  }
</script>

<style scoped>
  .cont-box {
    background-color: #08103c;
    min-height: 100%;
    padding-bottom: 3.6rem;
  }

  .title-header {
    width: 100%;
  }

  .resever {
    transform: scaleX(-1);
  }

  .title-cont {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .title-img {
    width: 80px;
  }

  .title {
    color: #2dfcff;
    font-size: 16px;
    font-weight: bold;
    padding: 0 10px;
    white-space: nowrap;
  }

  .map {
    padding: 10px 0;
  }

  .mapAll {
    padding-top: 20px;
    padding-bottom: 30px;
  }
  
  .nav {
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    z-index: 9999;
  }

  .nav>div {
    width: 50%;
    text-align: center;
    line-height: 3.6rem;
    background-color: #fafafa;
    box-sizing: border-box;
    color: #646464;
  }

  .nav>div.nav-cur {
    background-color: #24dadd;
    color: white;
  }

  .month-box {
    display: flex;
    flex-wrap: wrap;
    color: rgba(255, 255, 255, .5);
    padding: 30px 20px 0;
  }

  .month-box>div {
    box-sizing: border-box;
    width: 16.66%;
    text-align: center;
    margin-bottom: 14px;
    padding: 0 10px;
  }

  .month-box>div>span {
    display: inline-block;
    width: 100%;
    padding: 3px 0;
    background-color: rgba(255, 255, 255, .1);
    border-radius: 3px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 1);
  }

  .month-box>div.month-cur>span {
    color: white;
    background-color: #24dadd;
    box-shadow: 0 0 4px rgba(0, 255, 126, 1);
  }
  .time {
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, .6);
    font-size: 12px;
    padding: 6px;
  }
</style>
